import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan as trash, faLocationDot as loc, faCity as comp, faClock as date } from '@fortawesome/free-solid-svg-icons';
import { favoritesDelActivity, favoritesShow } from '../../store/favoritesSlice';
import getLogo from '../../utils/getLogo';
import { activityDate2Human } from '../../utils/dateTime';

const FavoritesActivities = ({ activities }) => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    // Переход на страницу активности
    const onClick = (item) => {
        dispatch(favoritesShow(false));
        // Нам надо учесть что мы можем быть в режиме виджета
        if(location.pathname.startsWith('/catalog/')) {
            navigate('/catalog/activity/' + item._id);
        } else {
            navigate('/widget/activity/' + item._id);
        }
    };

    // Удаление из избранного
    const onRemove = (e, item) => {
        e.stopPropagation();
        dispatch(favoritesDelActivity(item));
    };

    if(!activities || !activities.length) return t('favorites.noactivities');

	return (
        <div className='list'>
        {activities.map(item => (
            <div
                key={item._id}
                className='item'
                onClick={() => onClick(item)}
            >
                <img alt='icon' src={getLogo(item.exhibitor)}/>
                <div className='text'>
                    {item.name[lang]}
                    <div className='small'>
                        <FontAwesomeIcon icon={date} fixedWidth/> {activityDate2Human(item.date, lang)}
                    </div>
                    <div className='small'>
                        <FontAwesomeIcon icon={comp} fixedWidth/> {item.exhibitor.name[lang]}
                    </div>
                    {item.exhibitor.stand &&
                    <div className='small'>
                        <FontAwesomeIcon icon={loc} fixedWidth/> {item.exhibitor.stand}
                    </div>}
                    <div className='small'>{item.descr[lang]}</div>
                </div>
                <FontAwesomeIcon
                    className='remove'
                    icon={trash}
                    onClick={e => onRemove(e, item)}
                />
            </div>
        ))}
    </div>
	);
};

export default FavoritesActivities;
